import React, { useState } from "react";
import {Switch} from '@material-tailwind/react';

const RolePermissions = () => {
    const [roles, setRoles] = useState([
        {
            role: "Admin",
            permissions: [
                { name: "Manage Users", enabled: false },
                { name: "Edit Settings", enabled: false },
                { name: "View Reports", enabled: false },
            ],
        },
        {
            role: "Editor",
            permissions: [
                { name: "Create Content", enabled: false },
                { name: "Edit Content", enabled: false },
                { name: "Publish Content", enabled: false },
            ],
        },
        {
            role: "Viewer",
            permissions: [
                { name: "View Content", enabled: false },
                { name: "Download Reports", enabled: false },
            ],
        },
    ]);

    const handleToggle = (roleIndex, permissionIndex) => {
        setRoles((prevRoles) => {
            const updatedRoles = [...prevRoles];
            updatedRoles[roleIndex].permissions[permissionIndex] = {
                ...updatedRoles[roleIndex].permissions[permissionIndex],
                enabled: !updatedRoles[roleIndex].permissions[permissionIndex].enabled,
            };
            return updatedRoles;
        });
    };

    return (
        <div className="relative flex flex-col min-w-0 break-words w-full rounded-lg border-0">
            <div className="flex-auto py-10 pt-0">
                {roles.map((role, roleIndex) => (
                    <div
                        key={roleIndex}
                        className="my-3 p-4 border rounded-lg bg-white shadow-md"
                    >
                        <h6 className="text-lg font-bold text-blueGray-700 mb-4">{role.role}</h6>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {role.permissions.map((permission, permissionIndex) => (
                                <div
                                    key={permissionIndex}
                                    className="flex items-center justify-between p-2 bg-blueGray-50 rounded-md shadow-sm"
                                >
                        <span className="text-sm text-blueGray-600 font-medium">
                            {permission.name}
                        </span>
                                    <Switch
                                        id={`${role.role}-${permissionIndex}`}
                                        checked={permission.enabled}
                                        onChange={() => handleToggle(roleIndex, permissionIndex)}
                                        color="blue"
                                        ripple={true}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RolePermissions;



